module.exports = __webpack_public_path__ + "img/photosample.f54edfa7.png";